module.exports = __webpack_public_path__ + "assets/img/thumb-Solbari-Video.f427d32d.webp";